import PersonIcon from '@mui/icons-material/Person';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ContentWrapper } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/components/ContentWrapper';
import { StudentAvatar } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/components/StudentAvatar';
import { Wrapper } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/components/Wrapper';
import {
  GRID_AREA_NAME,
  GRID_AREA_GROUP,
} from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/constants';
import { Skeleton } from 'shared/components/Skeleton';

import type { SidebarAnimatedComponentsState as EmptyStateProps } from 'layout/MainLayout/components/Sidebar/types';
import type { FC } from 'react';

export const EmptyState: FC<EmptyStateProps> = ({ opened }) => {
  const { t } = useTranslation();

  return (
    <Wrapper opened={opened} readonly>
      <StudentAvatar
        alt={t('sidebar.studentSection.emptyState.avatarAlt')}
        opened={opened}
      >
        <PersonIcon />
      </StudentAvatar>
      <ContentWrapper opened={opened}>
        <Box gridArea={GRID_AREA_NAME}>
          <Skeleton width={120} height={12} animation={false} />
        </Box>
        <Box gridArea={GRID_AREA_GROUP}>
          <Skeleton width={80} height={8} animation={false} />
        </Box>
      </ContentWrapper>
    </Wrapper>
  );
};
